// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_e4-b";
export var colorBlue = "_e4-8";
export var colorDot = "_e4-0";
export var colorDotLarge = "_e4-2";
export var colorDotSmall = "_e4-1";
export var colorGreen = "_e4-7";
export var colorGrey = "_e4-3";
export var colorOrange = "_e4-5";
export var colorPink = "_e4-a";
export var colorPurple = "_e4-9";
export var colorRed = "_e4-4";
export var colorYellow = "_e4-6";